var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.1,
    height: 23,
    viewBox: "0 0 23.1 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5,21H20.4a.472.472,0,0,0,.5-.5V3.5c.1-.2-.2-.5-.4-.5H3.5a.642.642,0,0,0-.5.5V20.4A.648.648,0,0,0,3.5,21ZM4,4H20V20H4Z",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,11.4h-.7a6.224,6.224,0,0,0-5.8-5.7V5a.5.5,0,1,0-1,0v.7a6.309,6.309,0,0,0-5.8,5.7H5a.5.5,0,0,0,0,1h.7a6.416,6.416,0,0,0,5.8,5.9v.6a.5.5,0,0,0,1,0v-.6a6.252,6.252,0,0,0,5.8-5.9H19a.472.472,0,0,0,.5-.5A.536.536,0,0,0,19,11.4Zm-1.7,0H15.5a3.394,3.394,0,0,0-2.9-2.9V6.7A5.413,5.413,0,0,1,17.3,11.4Zm-5.8,0H9.6a2.617,2.617,0,0,1,1.9-1.9Zm0,1v2a2.569,2.569,0,0,1-2-2Zm1,0h2a2.569,2.569,0,0,1-2,2Zm0-1V9.6a2.339,2.339,0,0,1,1.9,1.9H12.5Zm-1-4.7V8.5a3.5,3.5,0,0,0-2.9,2.9H6.7A5.419,5.419,0,0,1,11.5,6.7ZM6.7,12.4H8.5a3.4,3.4,0,0,0,3,3v1.8A5.162,5.162,0,0,1,6.7,12.4Zm5.8,4.9V15.5a3.608,3.608,0,0,0,3-3h1.8A5.331,5.331,0,0,1,12.5,17.3Z",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1.6H1a.472.472,0,0,0-.5.5v22a.472.472,0,0,0,.5.5H23.1a.472.472,0,0,0,.5-.5V1.1A.472.472,0,0,0,23.1.6Zm-.5,22H1.5V1.6H22.6Z",
    fill: "#0080ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/stock.9f752269.svg";
export { ForwardRef as ReactComponent };